// extracted by mini-css-extract-plugin
export default {"tableContainer":"ShapefileInfo_tableContainer__8wmlO"};